import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { GroupsWidget } from 'components';
import { groups as groupsPath } from 'paths';
import { useGroupSearch } from 'hooks';

const RecommendedGroups: FC = () => {
  const { t } = useTranslation();
  const { results } = useGroupSearch({ results_from: 0, size: 3, auto_exclude: true });

  return (
    <GroupsWidget
      maxResults={3}
      maxWidth={180}
      link={groupsPath}
      results={results}
      title={t('groups:recommendedGroups')}
    />
  );
};

export default RecommendedGroups;
